import { getFormattedContactName } from 'v2/pages/conversations/utils'
import type { HandoffCaller } from 'v2/types/api/handoff-context'

interface HandoffPreviewDetailsProps extends Pick<HandoffCaller, 'source' | 'via'> {
  reason?: string | null
}

/** The source name is the "reported by" cue: the network never verified the displayed caller. */
export const HandoffPreviewDetails = ({ source, via, reason }: HandoffPreviewDetailsProps) => (
  <div
    className="flex flex-col gap-1 text-xs-400"
    aria-live="polite"
    data-testid="call-handoff-preview"
  >
    <p className="text-secondary break-words">
      {[`Handed off by ${source || 'external AI'}`, via && `line ${getFormattedContactName(via)}`]
        .filter(Boolean)
        .join(' · ')}
    </p>
    {reason && (
      <p className="break-words max-h-24 overflow-y-auto" data-testid="call-transfer-reason">
        <span className="text-xs-600">Transfer reason: </span>
        {reason}
      </p>
    )}
  </div>
)
